// extracted by mini-css-extract-plugin
export default {"title":"components-timeTracking-EditWorkTimeEntryBreaksWidget-__title","list":"components-timeTracking-EditWorkTimeEntryBreaksWidget-__list"};